import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import AddMrvFormLocal from "./AddMrvFormLocal";
import Swal from 'sweetalert2';
import RepairServices from "../../../services/RepairServices";


const RepairLocalOrders = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState([]);
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" },
  ]);
  const [partOptions, setPartOptions] = useState([]);

  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];
    if (!lastItem || !lastItem.id || !lastItem.name || lastItem.recivedQty <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Item',
        text: 'Please fill in all fields (Inventory, Name, and Required Qty) before adding a new item.',
        confirmButtonText: 'OK'
      });
      return;
    }
    setItems([...items, { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" }]);
  };

  const handleItemChange = (index, field, value) => {
    const numericValue = (field === "recivedQty" || field === "damageQty") ? parseFloat(value) : value;
    const newItems = [...items];
    newItems[index][field] = numericValue;

    if (field === "recivedQty") {
      if (numericValue > (newItems[index].approveQty - newItems[index].damageQty)) newItems[index].error = `Recived Qty cannot be greater than Approve Qty`;
      else if (numericValue < 0) newItems[index].error = `Recived Qty cannot be 0 or negative`;
      else newItems[index].error = "";
    }

    if (field === "damageQty") {
      if (numericValue > newItems[index].approveQty - newItems[index].recivedQty) newItems[index].error = `Damage Qty cannot be greater than Approve Qty`;
      else if (numericValue < 0) newItems[index].error = `Damage Qty cannot be 0 or negative`;
      else newItems[index].error = "";
    }

    setItems(newItems);
  };

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.id === selectedOption.value);
    if (isDuplicate) {
      Swal.fire({ icon: 'error', title: 'Duplicate Item', text: 'This item has already been added.', confirmButtonText: 'OK' });
      return;
    }
    handleItemChange(index, "id", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "approveQty", selectedOption.approveQty);
    handleItemChange(index, "qtyRequired", selectedOption.qtyRequired);
    handleItemChange(index, "description", selectedOption.description);
    handleItemChange(index, "unit", selectedOption.unit);
  };

  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  useEffect(() => {
    if (selectedStore) {
      setItems([{
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: 0,
        damageQty: 0,
        error: "",
        unit: ""
      }]);

      RepairServices.getMrv(selectedStore)
        .then((res) => {
          console.log("mryy", res)
          const filteredMrvs = res?.data?.data?.filter(m => {
            // ✅ Include only MRVs with supplier starting with "local"
            return m.supplier && m.supplier?.name?.toLowerCase().includes("local");
          });

          setMrv(filteredMrvs);
          setSelectedMrv(filteredMrvs[0]?._id || "");
        })
        .catch(console.log);
    }
  }, [selectedStore, run]);




  useEffect(() => {
    if (!selectedStore) return;
    const status = 'local';
    const poStatus = 'generated';
    RepairServices.getAllItem(undefined, status, selectedStore, poStatus)
      .then((res) => {
        console.log("hhh", res?.data?.data)
        const options = res?.data?.data?.map((item) => ({
          value: item._id,
          label: `${item.masterlist.partNo} | ${item.masterlist.description}`,
          approveQty: item.approveQty || 0,
          qtyRequired: item.qtyRequired || 0,
          description: item.masterlist?.description || "",
          unit: item.masterlist?.unit?.name || "",
        }));


        setPartOptions(options);
      })
      .catch(console.log);
  }, [selectedStore, selectedMrv, run]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      const total = Number(item.recivedQty) + Number(item.damageQty);

      if (item.recivedQty > item.approveQty - item.damageQty) {
        isValid = false; errorMessage = `Item ${index + 1}: Received Qty cannot exceed Approve Qty`;
      } else if (item.recivedQty < 0) {
        isValid = false; errorMessage = `Item ${index + 1}: Received Qty cannot be 0 or negative`;
      } else if (item.damageQty > item.approveQty - item.recivedQty) {
        isValid = false; errorMessage = `Item ${index + 1}: Damage Qty cannot exceed Approve Qty`;
      } else if (item.damageQty < 0) {
        isValid = false; errorMessage = `Item ${index + 1}: Damage Qty cannot be 0 or negative`;
      } else if (!selectedMrv) {
        isValid = false; errorMessage = `MRV Not Selected!`;
      }
    });

    if (!isValid) {
      Swal.fire({ title: 'Error!', text: errorMessage, icon: 'error', confirmButtonText: 'OK' });
      return;
    }

    RepairServices.localsubmitmrv({ mrvId: selectedMrv, items })
      .then(() => {
        Swal.fire({ title: 'Success!', text: 'Order received successfully', icon: 'success', confirmButtonText: 'OK' });
        setItems([{ name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" }]);
        setRun(run + 1);
      })
      .catch(() => Swal.fire({ title: 'Error!', text: 'Error during submission', icon: 'error', confirmButtonText: 'Retry' }));
  };


  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };
  const handleRequisitionForm = () => setIsModelOpen(true);

  const handleMrv = (e) => {
    setSelectedMrv(e.target.value);
    setItems([{ name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" }]);
    setPartOptions([]);
  };
  useEffect(() => {
    if (!selectedMrv) return;

    // Reset item rows when MRV changes
    setItems([
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: 0,
        damageQty: 0,
        error: "",
        unit: ""
      }
    ]);

    // Clear previous item dropdown options
    setPartOptions([]);
  }, [selectedMrv]);


  return (
    <>
      <AddMrvFormLocal show={isModelOpen} handleClose={() => setIsModelOpen(false)} store={stores} onSuccess={() => setRun(prev => prev + 1)} />
      <div className="row">
        <div className="col-xl-12">
          {/* Filter Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
              <div className="tools"><Link to="#" className={`SlideToolHeader ${open ? "collapse" : "expand"}`} onClick={() => setOpen(!open)}><i className="fas fa-angle-up"></i></Link></div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select Store</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={stores.map((store) => ({
                          value: store._id,
                          label: store.name,
                        }))}
                        value={
                          stores
                            .map((store) => ({
                              value: store._id,
                              label: store.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          handleStoreChange({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search Store..."
                        noOptionsMessage={() => "No stores found"}
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4 col-xxl-4">
                      <label>Select MRV No.</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={
                          mrv.length > 0
                            ? mrv.map((m) => ({
                              value: m._id,
                              label: m.repairMrvNo,
                            }))
                            : []
                        }
                        value={
                          mrv
                            .map((m) => ({
                              value: m._id,
                              label: m.repairMrvNo,
                            }))
                            .find((opt) => opt.value === selectedMrv) || null
                        }
                        onChange={(selected) =>
                          handleMrv({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search MRV No..."
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                      />
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <button className="btn btn-sm btn-primary mt-4 w-100" onClick={handleRequisitionForm}>Generate New MRV No</button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          {/* Add Item Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fa fa-plus me-2" aria-hidden="true"></i>Add MRV Item</div>
              <div className="tools"><Link to="#" className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`} onClick={() => setOpen2(!open2)}><i className="fas fa-angle-up"></i></Link></div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <form>
                      {items.map((item, index) => (
                        <div key={index} className="row">
                          <div className="form-group mb-2 col-md-3">
                            <label>Part Number</label>
                            <Select options={partOptions} onChange={(selectedOption) => handlePartSelect(index, selectedOption)} placeholder="Part" menuPortalTarget={document.body} styles={{ control: (base) => ({ ...base, minWidth: 90, height: 14, fontSize: '12px' }) }} />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Description</label>
                            <input type="text" className="form-control form-control-sm" value={item.description} readOnly />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Sent for Repair ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.qtyRequired} readOnly />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Approved ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.approveQty} readOnly />
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <label>Received ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.recivedQty} onChange={(e) => handleItemChange(index, "recivedQty", e.target.value)} />
                            <p className="text-danger">{item.error}</p>
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Damage ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.damageQty} onChange={(e) => handleItemChange(index, "damageQty", e.target.value)} />
                            <p className="text-danger">{item.error}</p>
                          </div>
                          <div className="form-group mb-1 col-md-1">
                            <button className="btn btn-danger btn-xs sharp mt-1" onClick={(e) => handleRemoveItem(e, index)}><i className="fa fa-trash"></i></button>
                          </div>
                        </div>
                      ))}
                      <div className="row mt-2">
                        <div className="col-md-2"><button className="btn btn-sm btn-primary" onClick={handleAddItem}>Add Item</button></div>
                        <div className="col-md-2"><button className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit</button></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default RepairLocalOrders;
